<template>
	<v-layout row wrap white--text class="section-app" id="whycasamarket">
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex xs12>
					<h1 class="section-app-main-title">¿Por qué debes ser parte de CASAMARKET?</h1>
				</v-flex>
				<v-flex
					xs12 md4 v-for="reason in reasons"
					:key="reason.id"
					class="section-app-padding"
				>
					<v-layout row wrap>
						<v-flex xs1 text-xs-right>
							<img
								src="/static/images/icons/icon-check-CM.svg"
								alt="viñeta para título"
								height="20"
							>
						</v-flex>
						<v-flex xs11 class="section-app-reason">
							<h3 class="section-app-title">
								{{ reason.title }}
							</h3>
							<p class="section-app-text">
								{{ reason.text }}
							</p>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	function data() {
		return {
			reasons: [
				{
					id: 1,
					title: 'Conveniencia y mayores beneficios para tus clientes',
					text: 'Podrás ofrecer a tus clientes un aplicativo móvil a través del cual pueden hacer y recibir pedidos 24/7, de manera más sencilla, segura y organizada.',
				},
				{
					id: 2,
					title: 'Promover que se tenga menos contacto',
					text: 'Los hábitos de consumo ya cambiaron, y hoy en día cuidar la salud es lo primero. Con tu aplicativo CasaMarket te cuidas tú y cuidas a tus clientes.',
				},
				{
					id: 3,
					title: 'Innovar, darle tecnología a tu negocio',
					text: 'Tendrás una herramienta muy potente para generar mayores ventas. Olvídate de hacer las cosas de manera manual, y apóyate de CasaMarket para gestionar mejor tu negocio',
				},
				{
					id: 4,
					title: 'Tener un ticket promedio más alto',
					text: 'Las ventas a través de un aplicativo móvil significan aproximadamente un 50% de incremento, lo cual va a ayudarte a generar mayores ingresos.',
				},
				{
					id: 5,
					title: 'Diferenciarte de tu competencia',
					text: 'Con CasaMarket tendrás una propuesta de valor diferenciada, y vas a destacar sobre tu competencia para tener nuevos y más fieles clientes.',
				},
				{
					id: 6,
					title: 'Gestionar mejor tu tiempo',
					text: 'Al recibir tus pedidos de manera ordenada, vas a organizar mejor tu tiempo, y así hacer crecer tu negocio. Recuerda que los clientes pueden ir a recoger sus pedidos en el momento que estén listos o esperar el delivery en la comodidad de su casa.',
				},
				{
					id: 7,
					title: 'Publicidad',
					text: 'Vas a poder publicitar mejor tu negocio con CasaMarket, ya que tienes una herramienta muy atractiva con este nuevo canal de ventas.',
				},
			],
		};
	}

	export default {
		name: 'section-app',
		data,
	};
</script>

<style lang="scss" scoped>
	.section-app {
		background-color: color(background);
		padding: 0px 5% 40px;

		@media (min-width: 360px) {
			padding: 0px 12% 40px;
		}

		@media (min-width: 1024px) {
			padding: 0px 7% 116px;
		}

		&-main-title {
			color: color(secondary);
			font-size: size(large35);
			font-weight: weight(w900);
			line-height: 1;
			margin: 93px 0px 57px;
			text-align: center;
			text-transform: uppercase;

			@media (min-width: 1024px) {
				margin: 90px 0px 102px;
			}
		}

		&-padding {
			@media (min-width: 1024px) {
				padding-right: 2%;
			}

			&:first-of-type {
				@media (min-width: 1024px) {
					margin-bottom: 27px;
				}
			}

			&:nth-child(2) {
				@media (min-width: 1024px) {
					margin-bottom: 27px;
				}
			}

			&:nth-child(3) {
				@media (min-width: 1024px) {
					margin-bottom: 27px;
				}
			}
		}

		&-reason {
			padding-left: 10px;
		}

		&-title {
			color: color(secondary);
			font-size: size(medium18);
			font-weight: weight(w900);
			margin-bottom: 10px;
		}

		&-text {
			color: color(info);
			font-size: size(medium16);
			margin-bottom: 36px;

			@media (min-width: 1024px) {
				margin-bottom: 0px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-app.vue